import React from "react";
import "./Loader.css";

export function Loader() {
  return (
    <div className="loader" role="status" aria-label="Carregando">
      <div className="loader__spinner" />
      <p className="loader__text">Carregando a promoção...</p>
    </div>
  );
}
